
export const Roles = {
    SuperAdmin: 'SUPERADMIN',
    Admin: "ADMIN",
    User: 'USER'
  }